import script from "./NewLicationList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewLicationList.vue?vue&type=script&setup=true&lang=js"

import "./NewLicationList.vue?vue&type=style&index=0&id=56751b05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56751b05"]])

export default __exports__